import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { DEX_API_URL } from '@skynet/config-provider';
import { prepareAuthHeaders } from '@skynet/data-auth-api';

/**
 * Base query for the DEX API.
 */
export const dexApiBaseQuery = fetchBaseQuery({
  baseUrl: DEX_API_URL,
  prepareHeaders: prepareAuthHeaders,
});
